let appConfig = require('../../config/index.js')
const ALL_API = { // 积分商城
  // 获取积分商品列表
  getScoreGoodsList: {
    baseURL: appConfig.API_URL_MARKET,
    method: 'get',
    url: '/api/score/getScoreGoodsList'
  },
  // 获取积分兑换详情
  getScoreRuleInfo: {
    baseURL: appConfig.API_URL_MARKET,
    method: 'get',
    url: '/api/score/getScoreRuleInfo'
  },
  // 获取积分兑换列表
  getScoreExchangeList: {
    baseURL: appConfig.API_URL_MARKET,
    method: 'get',
    url: '/api/score/getScoreExchangeList'
  },
  // 获取积分兑换记录详情
  getScoreExchangeInfo: {
    baseURL: appConfig.API_URL_MARKET,
    method: 'get',
    url: '/api/score/getScoreExchangeInfo'
  },
  // 会员兑换积分
  memberExchange: {
    baseURL: appConfig.API_URL_MARKET,
    method: 'post',
    url: '/api/score/memberExchange'
  },
  // 兑换积分 支持加钱兑换
  createScoreExchangeOrder: {
    baseURL: appConfig.API_URL_MARKET,
    method: 'post',
    url: '/api/market/order/createScoreExchangeOrder'
  }
}
export default ALL_API



// WEBPACK FOOTER //
// ./src/api/integral/mall.js